import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Table, TableProps } from "../../../../Common/UI/Index";
import "./Style.scss";

interface ListViewProps {
  /**
   * Table data
   */
  data: TableProps;
}

/**
 * Responsible for rendering the output configuration table
 * @param props consists of list 
 * @returns JSX element
 */
export const OutputConfigListView: React.FC<ListViewProps> = (props: ListViewProps) => {
  const { data } = props;
  const { t: translate } = useTranslation();

  return (
    <div className="ebt-output-config__list" id="ebt-outputConfig-tablelist">
      <Table
        id="ebt-outputConfig-table"
        tableData={data}
        emptyStateText={translate("OutputConfig.FinalOutputTable.NoEntries")}
      />
    </div>
  );
};
